import React from 'react';
import styles from './Private.module.css';

// Replace with your actual video path

const PrivateMobile = () => {
  return (
    <section className={styles.privateSection}>
      <div className={styles.videoContainer}>
        <video className={styles.backgroundVideo} autoPlay muted loop playsInline>
          <source src='./match-photos-mobile.mp4' type="video/mp4" />
          Your browser does not support the video tag.
        </video>

    
        <div className={styles.textOverlay}>
        <p className={styles.orangeTitle}>PRIVATE</p>
        <div className={styles.lineGroup}>
          <h2 className={styles.blackSubtitle}>No more judging based on appearances. Get to know real people, discover real stories and share experiences.</h2>
          <h3 className={styles.orangeSubtitle}>We are not a catalogue of faces</h3>
        </div>
        <div className={styles.lineGroup}>
          <h2 className={styles.blackSubtitle}>See each other only after matching <br/><br/>We use AI to block human faces from being uploaded as Posts <br/>There is no restriction for Match Photots, which are only visible to matches </h2>
          <h3 className={styles.orangeSubtitle}>No need to worry about prying eyes </h3>
        </div>
      </div>
      </div>
    </section>
  );
};

export default PrivateMobile;
